"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var clearState = function clearState() {
  return {};
};
var _default = exports["default"] = clearState;
//# sourceMappingURL=clearState.js.map